import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { AjaxService, FormValidationService } from 'src/app/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { areEqual } from 'src/app/shared/messages';

@Component({
  selector: 'app-patient-form',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.less']
})
export class PatientComponent implements OnInit {

  constructor(private _translateService: TranslateService,
    private _formValidationService: FormValidationService,
    private _ajaxService: AjaxService,
    private _confirmationService: ConfirmationService,
    private _dataService: CommonDataService,
    private location: Location,
    private _router: Router) { }

  signupform = new FormGroup({});
  signupmodel: any = {};
  signupoptions: FormlyFormOptions = {};
  signupfields: FormlyFieldConfig[] = [];

  ngOnInit(): void {
    this.createSignUpForm();
    this._dataService.getUserDetails().subscribe(result => {
      const data = result.data;
      this.signupmodel = { ...data.Patient };
    });
  }

  get isEditAccountPage() {
    return this._router.url.indexOf('edit-information') !== -1;
  }

  createSignUpForm() {
    this.signupfields = [
      {
        key: 'Salutation',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            { label: 'MR', value: 'MR' },
            { label: 'MRS', value: 'MRS' },
            { label: 'MS.', value: 'MS.' },
            { label: 'Dr', value: 'Dr' },
            { label: 'Other', value: 'Other' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSalutation'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'FirstName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblFirstName'),
        }
      },
      {
        key: 'LastName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblLastName'),
        }
      },
      {
        key: 'Email',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmail'),
          'templateOptions.disabled': (model, formState) => this.isEditAccountPage
        }
      },
      {
        key: 'Password',
        type: 'password',
        hide: this.isEditAccountPage,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblPassword'),
        }
      },
      {
        key: 'ConfirmPassword',
        type: 'password',
        hide: this.isEditAccountPage,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true,
          showPswdStrength: false
        },
        validators: {
          fieldMatch: {
            expression: (control: any) => {
              const value = control.value;
              if (control.parent && control.parent.controls && control.parent.controls.Password && control.parent.controls.Password.value) {
                return value === control.parent.controls.Password.value
                  || (!value || !control.parent.controls.Password.value);
              }
              return null;
            },
            message: areEqual,
          },
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblConfirmPassword'),
        }
      },
      {
        key: 'MobileNo',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblMobileNo'),
          'templateOptions.disabled': (model, formState) => this.isEditAccountPage
        }
      },
      {
        key: 'Address',
        type: 'textarea',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAddress'),
        }
      },
      {
        key: 'DOB',
        type: 'date-picker',
        wrappers: ['fieldWrapper'],
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblDOB'),
        },
      },
      {
        key: 'PreferredCurrency',
        type: 'dropdown',
        hide: true,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            { label: '$', value: 'dollar' },
            { label: 'Rs.', value: 'INR' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblPreferredCurrency'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'Sex',
        type: 'dropdown',
        defaultValue: null,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            { label: 'Male', value: 'male' },
            { label: 'Female', value: 'female' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSex'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect'),
        }
      },
      {
        key: 'MaritialStatus',
        type: 'select',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          options: [
            { label: 'Single', value: 'Single' },
            { label: 'Married', value: 'Married' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblMaritalStatus'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect'),

        }
      },
      {
        key: 'EmergencyContact',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmergencyContactName'),
        }
      },
      {
        key: 'Relationship',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblRelationship'),
        }
      },
      {
        key: 'LblEmergencyContactNo',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmergencyContactNo'),
        }
      },
      {
        key: 'CouponCode',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblCouponCode'),
        }
      }
    ];
  }

  registerClicked() {
    const value = { ...this.signupmodel };
    console.log(value);
    if(value.AffiliateId!==null){
      value.AffiliateId=value.AffiliateId.toString();
    }
    value.MobileNo = value.CountryCode + '' + value.MobileNo;
    console.log(value.CouponCode);
    this._formValidationService.markFormGroupTouched(this.signupform);
    if (this.signupform.valid) {
      this._ajaxService.post('/patient/register', value).subscribe((response) => {
        const result = response.data;
        if (response.success) {
          this._confirmationService.confirm({
            message: (this.isEditAccountPage) ? this._translateService.instant('LblPatientUpdated') : this._translateService.instant('LblPatientRegistered'),
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              //Actual logic to perform a confirmation
              if (!this.isEditAccountPage) {
                this.signupform.reset();
              } else {
                this.signupmodel = {
                  ...result
                }
                this.location.back();
              }
            }
          });
        }else if(!response.success){
          this._confirmationService.confirm({
            message: (response.error),
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              
            }
          });
        }
      }, error => {
        this._confirmationService.confirm({
          message: error.error.error,
          rejectVisible: false,
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this._translateService.instant('LblOk'),
          accept: () => {
            //Actual logic to perform a confirmation
          }
        });
      });
    }
  }

  cancelClicked() {
    this.location.back();
  }

}
